import { useEffect, useState } from 'react';
import { NavBar } from '../../../../../themes/components/Navbar';
import { Sidebar } from '../../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FooterRelatorios } from '../../../components/FooterRelatorios';
import { VscRunAll } from 'react-icons/vsc';
import { AiOutlineClear } from 'react-icons/ai';
import { Button } from '../../../../../themes/components/Button';
import { useRelatorios } from '../../../../../contexts/Relatorios';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../../contexts/Modals';
import { ContainerRelatorio } from '../../../components/VisualizarRelatorio';
import { compareDatasAntigas, mascaraDataMMAAAA, isValidStringDate } from '../../../../../util/fieldMasks';
import Typography from '@material-ui/core/Typography';
import { FieldDropdown } from '../../../../../themes/components/FieldDropdown';
import moment from 'moment';

export const RFNF520 = () => {
    const history = useHistory();
    const { mostrarInfoOK } = useModals();
    const { loadingRelatorio, urls, setUrls, gerarRelatorio, setLoadingRelatorio } = useRelatorios();
    const [dataEmissao, setDataEmissao] = useState<string>("");

    const [estoque, setEstoque] = useState("Todos");
    const [iEstoque, setIEstoque] = useState("");
    const optEstoque = [
        { "cod": "", "nome": "Todos" },
        { "cod": "2", "nome": "GA" },
        { "cod": "4", "nome": "AB" }
    ];

    useEffect(() => {
        setUrls((prevState) => ({
            ...prevState,
            "RFNF520": ""
        }))
        // component unmount 
        return () => {
            setLoadingRelatorio((prevState) => ({
                ...prevState,
                "RFNF520": false
            }))
        }
    }, []);

    const handleChangeDataEmissao = (event: React.ChangeEvent<{ value: unknown }>) => {
        setDataEmissao((event.target.value as string).substring(0, 7));
    };

    function handleClearFields() {
        setDataEmissao("");
    }

    function solicitarRelatorio() {
        let dataCampo = "01/" + dataEmissao;
        if (isValidStringDate(dataCampo) && moment(dataCampo, "DD/MM/YYYY").isValid()) {
            if (compareDatasAntigas(moment().toDate(), moment(dataCampo, "DD/MM/YYYY").toDate())) {
                let objParams: any = [];
                if(iEstoque != ""){
                    objParams.push({ nome: "DATEMI", valor: dataCampo }, { nome: "CODEMP", valor: iEstoque });
                }else{
                    objParams.push({ nome: "DATEMI", valor: dataCampo });
                }
                setUrls((prevState) => ({
                    ...prevState,
                    "RFNF520": ""
                }))
                gerarRelatorio("RFNF520", JSON.parse(JSON.stringify(objParams)), history)
            } else {
                setUrls((prevState) => ({
                    ...prevState,
                    "RFNF520": ""
                }))
                mostrarInfoOK("O período precisa ser do mês atual ou anterior!");
            }
        } else {
            setUrls((prevState) => ({
                ...prevState,
                "RFNF520": ""
            }))
            mostrarInfoOK("A data informada não é válida!");
        }

        if (dataEmissao === "") {
            mostrarInfoOK("Campo de Data é obrigatório!");
        } else {

        }
    }

    function getEstoqueList() {
        let temp: string[] = []
        optEstoque.forEach((opt) => {
            temp.push(opt.nome)
        })
        return temp;
    }

    function getCodEstoque(text: string) {
        let sit = "";
        optEstoque.forEach((opt) => {
            if (opt.nome === text) {
                sit = opt.cod;
            }
        })
        return sit;
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-relatorios">
                    <NavBar />
                    <span className="novo-pedido-title-form">Parâmetros do Relatório</span>
                    <div className="relatorios-campo-busca">
                        <form>
                            <div className="form-row">
                                <div className="form-group" >
                                    <label htmlFor="consulta-combobox-tipo-pedido">Período da Emissão</label>
                                    <div className="pedido-linha-campo">
                                        <input type="text" className="form-control" id="cod-cliente-rel" name="cod-cliente-rel" onChange={handleChangeDataEmissao} value={mascaraDataMMAAAA(dataEmissao)} placeholder='MM/AAAA' />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <label htmlFor="consulta-combobox-tipo-pedido">Empresa</label>
                                    <div className={""}>
                                        <FieldDropdown
                                            value={estoque}
                                            id="seleciona-combobox-estoque"
                                            options={getEstoqueList()}
                                            label={(option: string) => option}
                                            onChange={(event, newInputValue) => {
                                                setEstoque(newInputValue);
                                                setIEstoque(getCodEstoque(newInputValue));
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="form-buttons">
                                    <Button titleText="Gerar relatório" classBtn="" onClick={() => solicitarRelatorio()} >
                                        <VscRunAll color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                    <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                                        <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {loadingRelatorio.RFNF520 === true ?
                        <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                        :
                        urls['RFNF520'] !== "" ?
                            <ContainerRelatorio arquivoUrl={urls['RFNF520']} />
                            : <></>
                    }
                </div>
                <FooterRelatorios funcGerar={() => solicitarRelatorio()} funcImprimir={() => { }} regraGerar={true} regraImprimir={false} />
            </div>
            <Toaster />
        </div>
    )
}